export interface IMediaItem {
  /** Текст для атрибута alt **/
  alt: string;
  /** Ссылка на исходное медиа **/
  fullUrl: string;
  /** ID медиа **/
  id: number;
  /** Главное изображение **/
  isPrimaryImage?: boolean;
  /** Тип медиа **/
  mediaType: EMediaType;
  /** Ссылка на YouTube **/
  videoUrl?: string;
  /** Тип видео, если медиа является видео **/
  videoType?: TVideoType;
}

export enum EMediaType {
  /** Изображение **/
  'Image' = 'image',
  /** Карта **/
  'Map' = 'map',
  /** Видео **/
  'Video' = 'video',
}

export type TVideoType = 'vk' | 'youtube' | 'rutube';
